<template>
	<div class="rewending-wrap">
		<div class="rewending-list">
			<van-empty v-if="list.length == 0" description="暂无数据" />
			<div class="rewending-item" v-for="item in list" :key="item.id">
				<div class="list-item">
					<span>充装气站</span>
					<span >{{item.netName}}</span>
				</div>
				<div class="list-item">
					<span>条码</span>
					<span >{{item.barcode}}</span>
				</div>
				<div class="list-item">
					<span>灌装编号</span>
					<span >{{item.fillingCode}}</span>
				</div>
				<div class="list-item">
					<span>机器编号</span>
					<span >{{item.machineCode}}</span>
				</div>
				<div class="list-item">
					<span>皮重</span>
					<span >{{item.paperWeight}}</span>
				</div>
				<div class="list-item">
					<span>灌装前重量</span>
					<span >{{item.beforeWeight}}</span>
				</div>
				<div class="list-item">
					<span>灌装后重量</span>
					<span >{{item.endWeight}}</span>
				</div>
				<div class="list-item">
					<span>灌装设定量</span>
					<span >{{item.settingWeight}}</span>
				</div>
				<div class="list-item">
					<span>实际灌装量</span>
					<span >{{item.actualWeight}}</span>
				</div>
				<div class="list-item">
					<span>灌装开始时间</span>
					<span >{{item.beginTs}}</span>
				</div>
				<div class="list-item">
					<span>灌装结束时间</span>
					<span >{{item.endTs}}</span>
				</div>
				<div class="list-item">
					<span>状态</span>
					<div v-if="item.status != 1">
						<span style="color: #D52648">{{item.status==2?'过期':(item.status==3?'过检':'未知')}}</span>
					</div>
					<div v-else>
						<span>正常</span>
					</div>
					
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {Toast, Dialog} from 'vant'
	import moment from 'moment'
	
	export default {
		data () {
			return {
				list: [],
				code : '',
			}
		},
		methods: {
			getTankFillList (code) {
				this.$api.post('get_tank_fill_list.php', {
					barcode: code
				}).then(res => {
					let list = [];
					res.rows.forEach(function(item){
						list.push({
							netName: item.net_name,
							barcode: item.barcode,
							fillingCode: item.filling_code,
							machineCode: item.machine_code,
							paperWeight: item.paper_weight,
							beforeWeight: item.before_weight,
							endWeight: item.end_weight,
							settingWeight: item.setting_weight,
							actualWeight: item.actual_weight,
							beginTs: item.begin_ts,
							endTs: item.end_ts,
							status: item.status
						});
					});
					this.list = list;
				})
			},
		},
		created () {
			let code = localStorage.getItem('code');
			console.log("%%", code);
			this.code = code;
			this.getTankFillList(code)
		}
	}
</script>

<style lang="less" scoped>
	.rewending-list {
		top: 0;
		left: 0;
		right: 0;
		bottom: 55px;
		padding-bottom: 60px;
		overflow: scroll;
		background-color: #fafafa;
		.rewending-item {
			margin-top: 5px;
			background-color: #fff;
			padding: 10px 16px;
			.list-item {
				display: flex;
				justify-content: space-between;
				span:nth-child(2) {
					color: #a3a3a3;
				}
				span:nth-child(1) {
					color: #3c3c3c;
				}
				&:nth-child(1) {
					padding: 5px 0;
					span:nth-child(1) {
						font-size: 16px;
					}
				}
			}
		}
	}
	.van-button--mini {
		height: 26px;
		line-height: 26px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
</style>
